import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { map } from 'rxjs/operators';
import { IOption } from '../../../models/Models';
import { ScrollService } from '../../../services/scroll/scroll.service';

@Component({
  selector: 'ff-filter-dropdown',
  templateUrl: './filter-dropdown.component.html',
  styleUrls: ['./filter-dropdown.component.scss']
})
export class FilterDropdownComponent implements OnInit {
  @ViewChild(MatAutocompleteTrigger) trigger: MatAutocompleteTrigger;

    /**
     * Options to display as radio buttons
     * Use the IOption interface: { value: string; text: string; selected?: boolean; }
     * @internal
    */
    @Input() options: IOption[] = [];

    private originalOptions: IOption[] = [];

    /**
     * The default selected value of the dropdown
     */
    @Input() set default(option: IOption) {
      //if(!option) return;

      if (this.selectedValue.value !== option?.value) {
        if (this.selectedValue.value === '') {
          this.formControl.setValue(this.selectedValue = option, { emitEvent: false });
        } else {
          this.formControl.setValue(this.selectedValue = option, { emitEvent: true });
          this.onSelectionChange();
        }
      }
    }

    /**
     * Emit the value selected by the user
     * @internal
     */
    @Output() elementSelected = new EventEmitter<IOption>();

    formControl = new FormControl();

    selectedValue: IOption = {
      text: '',
      value: '',
      selected: false
    };

    constructor(private scrollService: ScrollService) { }

    /**
     * Callback to apply custom filtering on the option list.
     * If provided it must set the options input with the filter result.
     * By default if filters all options where the display text starts with the input, case insensitive.
     * @param input Filtering value provided by the user
     */
    filter(input: string) {
      input = input.toLocaleLowerCase();
      this.options = this.originalOptions.filter(
        option => option.text.toLocaleLowerCase().includes(input)
      );
      this.selectedValue = null;
    };

    ngOnInit(): void {
      this.originalOptions = [...this.options];
      this.formControl.valueChanges.pipe(
        map(value => typeof value === "string" ? value : value.text)
      ).subscribe(value => this.filter(value));
      this.scrollService.scrollEvent.subscribe(() => {
        this.trigger.closePanel();
      });
    }

    display(option: IOption) {
      return option?.text ?? '';
    }

    onSelectionChange(): void {
      this.elementSelected.emit(this.selectedValue = this.formControl.value);
    }

    //form value will be resetted on close UNTIL an option is selected from dropdown
    async handleClose(){
      await Promise.resolve()
      .then(() => setTimeout(() => this.validateFormControl(), 500));
    }

    validateFormControl(){
      if(!this.selectedValue){
        this.formControl.patchValue('')
        this.formControl.updateValueAndValidity();
        this.trigger.closePanel();
        this.onSelectionChange();
      }
    }
    
  /**
  * Emits when the dropdown menu is opened
  */
  @Output() opened = new EventEmitter();

  /**
   * Emits when the dropdown menu is closed
   */
  @Output() closed = new EventEmitter();

  onOpened($event): void {
    this.opened.emit($event);
  }

  onClosed($event): void {
    this.closed.emit($event);
  }

  focusOut(): void {
    if (this.formControl.value === null) {
      this.onSelectionChange();
    }
  }
}
